import React from 'react'

import { Step } from "../../../Stepper"
import { TitleSetter, BodySetter, FooterSetter, NextButton } from "../../../Stepper/layouts/MDB"
import { Right } from "../../../Stepper/layouts/default"
import { useStepper } from "../../../Stepper/utils"
import { NonIdealState } from '../../..'

export const CompleteProfileWarningStep = () => {
	const { next } = useStepper()

	return <Step>
		<TitleSetter>Complete seu cadastro</TitleSetter>
		<BodySetter>
			<NonIdealState
				icon="fill-forms"
				title="Seu perfil é importante"
				description="Precisamos coletar algumas informações adicionais sobre você."
			/>
		</BodySetter>
		<FooterSetter>
			<Right>
				<NextButton
					onClick={next}
				>Vamos lá!</NextButton>
			</Right>
		</FooterSetter>
	</Step>
}